// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1PThx","infoBtn":"quickbooks_infoBtn__9sF9W","formBox":"quickbooks_formBox__8Ez7r","formFooter":"quickbooks_formFooter__Ep6uQ"};